exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-content {\n  height: 100%;\n  width: 100%;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding: 1.5rem;\n  font-size: 3rem;\n  text-transform: uppercase;\n  font-family: \"RobotoMedium\", sans-serif;\n  background: #b3b3b3; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/app/pages/dashboard/dashboard.component.scss
// module id = ../../../../../src/app/pages/dashboard/dashboard.component.scss
// module chunks = 2